import React, {useEffect, useState} from 'react';
import {Box, Card, CardContent, Typography} from '@mui/material';

interface Props {
	final: any[];
}

const QUESTIONS = [
	'question49',
	'question54',
	'question59',
	'question64',
	'question69',
	'question74',
	'question79',
	'question84',
	'question89',
	'question94',
	'question99',
	'question104',
];

const TotalObtainedFunds = ({final}: Props) => {
	const [total, setTotal] = useState<string>('');

	const calculate = () => {
		let yes = 0;

		final.forEach((submission) => {
			const gotYes = QUESTIONS.some((q) => submission[q] === 'Item 1');
			if (gotYes) yes++;
		});

		const pct = final.length > 0 ? (yes / final.length) * 100 : 0;
		setTotal(`${pct.toFixed(1)}%`);
	};

	useEffect(() => {
		calculate();
	}, [final]);

	return (
		<Card className='chart-container'>
			<CardContent>
				<div className='enrolled-item space-x-4'>
					<Box
						sx={{
							minWidth: '5rem',
							p: 1,
							border: '1px solid grey',
							textAlign: 'right',
							fontSize: '1.25rem',
							backgroundColor: 'rgb(243, 244, 246)',
						}}
					>
						{total}
					</Box>
					<Typography>% of all entrepreneurs who obtained funds</Typography>
				</div>
			</CardContent>
		</Card>
	);
};

export default TotalObtainedFunds;
